import {NgModule} from '@angular/core';
import {TooltipDirective} from './tooltip.directive';
import {ClickOutsideDirective} from './click-outside.directive';
import {MatSelectAccessorDirective} from './select-scroll-to-option.directive';
import {BlurOnComponentDirective} from './blur-on-component.directive';
import {PermissionGuardDirective} from './permission-guard.directive';
import {OnlyRegTrackModeGuardDirective} from './only-reg-track-mode-guard.directive';
import {ReapplyFocusDirective} from './reapply-focus.directive';
import {UppercaseValueDirective} from './uppercase-value.directive';
import {DetectOverflowDirective} from './detect-overflow.directive';
import {ScrollToElementDirective} from './scroll-to-element.directive';

@NgModule({
  imports: [],
  declarations: [
    TooltipDirective,
    ClickOutsideDirective,
    MatSelectAccessorDirective,
    BlurOnComponentDirective,
    PermissionGuardDirective,
    OnlyRegTrackModeGuardDirective,
    ReapplyFocusDirective,
    UppercaseValueDirective,
    DetectOverflowDirective,
    ScrollToElementDirective,
  ],
  exports: [
    TooltipDirective,
    ClickOutsideDirective,
    MatSelectAccessorDirective,
    BlurOnComponentDirective,
    PermissionGuardDirective,
    OnlyRegTrackModeGuardDirective,
    ReapplyFocusDirective,
    UppercaseValueDirective,
    DetectOverflowDirective,
    ScrollToElementDirective,
  ],
})
export class DirectivesModule {}
